module.exports = __webpack_public_path__ + "img/move.0bd6a6eb.svg";